import { sessionIdName } from 'const/session'
import { getAppSessionItem } from 'helpers/appSessionItem'
import { getCookie } from 'helpers/cookie'

/**
 * Gets the auth session id stored in session storage.
 * No prefix to make session id cross trackable.
 * @returns the session id string
 */
const getSessionID = (): string => {
  const sessionId = getAppSessionItem(sessionIdName)
  const cookieSessionId = getCookie(sessionIdName) ?? ''

  return sessionId || cookieSessionId
}

export default getSessionID
